@if (canRefuseValidation) {
  <button mat-icon-button (click)="refuseValidation()" matTooltip="Demander des modifications">
    <mat-icon class="flip-horizontal error">refresh</mat-icon>
  </button>
}
